import React from "react";
import type { SpecsModel } from "../../specsModel/SpecsModel";
import { useSpecsModel, useSpecsModelSelector } from "../../SpecsModelContext";
import { SpecsInputField } from "../../SpecsEditorFields/index";

type SpecsModelInputFieldProps = Omit<
  React.ComponentProps<typeof SpecsInputField>,
  "value" | "onChange"
> & {
  selector: (model: SpecsModel) => string;
  setValue: (
    model: SpecsModel,
    nextValue: string,
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
};

export default function SpecsModelInputField({
  selector,
  setValue,
  ...props
}: SpecsModelInputFieldProps) {
  const model = useSpecsModel();
  const value = useSpecsModelSelector(selector);

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setValue(model, event.target.value, event);
    },
    [model, setValue]
  );

  return <SpecsInputField {...props} value={value} onChange={handleChange} />;
}
